<!-- <page-header title="Add Vehicle"></page-header> -->

 
      <form [formGroup]="form" class="form-field-full" fxLayout="column" fxLayoutAlign="start" fxFlex="1 0 auto">
        <mat-card-title style="padding-bottom:20px">Change Configuration</mat-card-title>

        <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="20px"  fxFlex="1 0 auto">
          <mat-form-field appearance="outline" fxFlex="100" class="pr-4" *ngIf="!isConfigEdit" >
                  <mat-label>Key</mat-label>
                  <input type="text" matInput formControlName="key"  [matAutocomplete]="auto4" required>
                  <mat-autocomplete #auto4="matAutocomplete"    (optionSelected)='onKeyChange($event.option.value.key)' [displayWith]="displayChangeKey">
                    <mat-option *ngFor="let option of filteredOptionsChangeKey | async" [value]="option" >
                        {{option.key}}
                      </mat-option>
                  </mat-autocomplete>
                    <mat-icon matSuffix class="secondary-text">expand_more</mat-icon>
              </mat-form-field>
          <mat-form-field appearance="outline" fxFlex="100" class="pr-4" *ngIf="isConfigEdit">
            <mat-label>Key</mat-label>
            <input matInput placeholder="" autocomplete="off" formControlName="key" >
          </mat-form-field>
        </div>
        <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="20px"  fxFlex="1 0 auto"  *ngIf="isConfigEdit">
          <mat-form-field  appearance="outline" fxFlex="100" class="pr-4" >
            <mat-label>Value</mat-label>
            <input matInput placeholder="" autocomplete="off" formControlName="cValue"  >
          </mat-form-field>
        </div>
        <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="20px"  fxFlex="1 0 auto" *ngIf="!isConfigEdit">
          <mat-form-field appearance="outline" fxFlex="100" class="pr-4" *ngIf="numberType">
            <mat-label>New Value</mat-label>
            <input matInput placeholder="" type="number" maxlength="200" formControlName="cValue" required min="0">
          </mat-form-field>
          <mat-form-field appearance="outline" fxFlex="100" class="pr-4" *ngIf="boolenaType"  >
            <mat-label>New Value</mat-label>
              <mat-select disableRipple formControlName="cValue">
                <mat-option value="true">True</mat-option>
                <mat-option value="false">False</mat-option>
              </mat-select>
          </mat-form-field>
          <mat-form-field appearance="outline" fxFlex="100" class="pr-4" *ngIf="stringType"  >
            <mat-label>New Value</mat-label>
            <input matInput placeholder=""  maxlength="200" formControlName="cValue" required min="0" >
          </mat-form-field>
          <mat-form-field appearance="outline" fxFlex="100" class="pr-4" *ngIf="alfanumeric"  >
            <mat-label>New Value</mat-label>
            <input matInput placeholder=""  maxlength="200" formControlName="cValue" required min="0" >
          </mat-form-field>
        </div>
      
        <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="20px"  fxFlex="1 0 auto" *ngIf="isConfigEdit">
          <mat-form-field appearance="outline" fxFlex="100" class="pr-4" *ngIf="numberType">
            <mat-label>New Value</mat-label>
            <input matInput placeholder="" type="number" maxlength="200" formControlName="newValue" required min="0">
          </mat-form-field>
          <mat-form-field appearance="outline" fxFlex="100" class="pr-4" *ngIf="boolenaType"  >
            <mat-label>New Value</mat-label>
              <mat-select disableRipple formControlName="newValue">
                <mat-option value="true">True</mat-option>
                <mat-option value="false">False </mat-option>
              </mat-select>
          </mat-form-field>
          <mat-form-field appearance="outline" fxFlex="100" class="pr-4" *ngIf="stringType"  >
            <mat-label>New Value</mat-label>
            <input matInput placeholder=""  maxlength="200" formControlName="newValue" required min="0">
          </mat-form-field>
          <mat-form-field appearance="outline" fxFlex="100" class="pr-4" *ngIf="alfanumeric"  >
            <mat-label>New Value</mat-label>
            <input matInput placeholder=""  maxlength="200" formControlName="newValue" required min="0">
          </mat-form-field>
        </div>
        <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="20px"  fxFlex="1 0 auto" *ngIf="isConfigEdit">
          
        </div>
        <div fxLayout="row" fxLayoutAlign="start center" style="padding-top:10px">  
          <button mat-raised-button color="primary"  (click)="getNewConfiguration()" type="button" class="mr-8">Perform</button>
              <button mat-raised-button type="button"  (click)="close()" color="warn" class="mr-8" >Cancel</button>
        </div>
     
      </form>
                                        

    